// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import authentication from './store/authentication'
import fontawesome from '@fortawesome/fontawesome'
import faSync from '@fortawesome/fontawesome-free-solid/faSync'

fontawesome.library.add(faSync)
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  authentication,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js